module.exports = __webpack_public_path__ + "static/img/kwh_good4.bf37ba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/goods/kwh_good4.png
// module id = yRxN
// module chunks = 1